import { colors, layers, media, radius, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

interface StepWrapperProps {
  isLast?: boolean;
}

export const StepWrapper = styled.div<StepWrapperProps>`
  display: flex;
  position: relative;
  height: max-content;
  user-select: none;

  &:not(:last-child) {
    min-height: 100px;
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    width: 0.2rem;
    height: 100%;
    background-color: ${colors.primary};
    top: 0;
    left: calc(3rem / 2);
  }

  ${media.greaterThan('tablet')`
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 1;
    height: max-content;
  `}

  ${({ isLast }) =>
    !isLast &&
    css`
      ${media.greaterThan('tablet')`
        &::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 0.2rem;
          background-color: ${colors.primary};
          top: calc(3rem / 2);
          left: 0;
        }
      `}
    `}
`;

export const StepText = styled.div`
  ${media.greaterThan('tablet')`
    padding-right: ${spacing.medium};
  `};
`;

export const StepIndicator = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  background-color: ${colors.primary};
  border-radius: ${radius.large};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  margin-right: ${spacing.medium};
  position: relative;
  z-index: ${layers.above};
  margin-bottom: ${spacing.medium};

  ${media.greaterThan('tablet')`
    margin-bottom: ${spacing.medium};
  `}
`;
